// extracted by mini-css-extract-plugin
export default {"box":"S8Bf_UtPLtOIBfSlijPi"};